import { render, staticRenderFns } from "./Pickup.vue?vue&type=template&id=6405b02c&scoped=true&"
import script from "./Pickup.vue?vue&type=script&lang=js&"
export * from "./Pickup.vue?vue&type=script&lang=js&"
import style0 from "./Pickup.vue?vue&type=style&index=0&id=6405b02c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405b02c",
  null
  
)

export default component.exports